import { MEMBERS_AREA as MEMBERS_AREA_APP_DEF_ID } from '@wix/app-definition-ids';
import { ControllerFlowAPI } from '@wix/yoshi-flow-editor';

import { MY_REWARDS_APP_DEF_ID, MY_REWARDS_SECTION_ID, MY_REWARDS_WIDGET_ID } from '../constants';

export async function getMyRewardsPageUrl(flowAPI: ControllerFlowAPI): Promise<string> {
  const { wixCodeApi } = flowAPI.controllerConfig;

  try {
    const membersApi = await wixCodeApi.site.getPublicAPI(MEMBERS_AREA_APP_DEF_ID);

    // Will throw if "My Rewards" app is not installed
    const myRewardsUrl = await membersApi?.getSectionUrl({
      appDefinitionId: MY_REWARDS_APP_DEF_ID,
      sectionId: MY_REWARDS_SECTION_ID,
      widgetId: MY_REWARDS_WIDGET_ID,
    });

    return myRewardsUrl ?? '';
  } catch {}

  return '';
}
